export default __webpack_public_path__ + "static/media/basiercirclemono-regular-webfont.cd8ccf8f.eot";